import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import { Store } from '../../store'

/**
 * Body of modal used to edit org chart nodes
 */
@ngCore.Component({
  imports: [
    ds.input.text.Component,
    ds.input.textArea.Component,
    ds.input.select.single.Component,
  ],
  selector: 'atn-summit-org-chart-node-panel-body',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /** @see {@link OrgChart.Node.TYPES} */
  public readonly nodeTypes = state.summit.orgChart.models.Node.TYPES
}
